import { SwiperSlide } from 'swiper/react';
import { Project } from '@y2/api-clients/yad1';

import styles from './projects-in-your-area.module.scss';
import texts from './projects-in-your-area.texts.json';
import { CommonCarousel } from '../../components/carousel';
import { ProjectInYourAreaItem } from '../project-item/project-in-your-area-item/project-in-your-area-item';

type ProjectsInYourAreaProps = {
  projects: Project[];
  onProjectClick: (projectId: string) => void;
};

export const ProjectsInYourArea = ({
  projects,
  onProjectClick,
}: ProjectsInYourAreaProps) => {
  const handleProjectClick = (projectId: string) => () => {
    onProjectClick(projectId);
  };

  return (
    <div>
      <h3 className={styles.header}>{texts.header}</h3>
      <CommonCarousel>
        {projects.map((project) => (
          <SwiperSlide className={styles.slide} key={project.id}>
            <ProjectInYourAreaItem
              project={project}
              onClick={handleProjectClick(project.yad2Id?.toString())}
            />
          </SwiperSlide>
        ))}
      </CommonCarousel>
    </div>
  );
};
